var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333496 21.6667V48.3333C0.333496 51.2788 2.72131 53.6667 5.66683 53.6667H32.3335C35.279 53.6667 37.6668 51.2788 37.6668 48.3333V37.6667H48.3335C51.279 37.6667 53.6668 35.2788 53.6668 32.3333V5.66666C53.6668 2.72114 51.279 0.333328 48.3335 0.333328H21.6668C18.7213 0.333328 16.3335 2.72114 16.3335 5.66666V16.3333H5.66683C2.72131 16.3333 0.333496 18.7211 0.333496 21.6667ZM37.6668 32.3333V21.6667C37.6668 18.7211 35.279 16.3333 32.3335 16.3333H21.6668V5.66666H48.3335V32.3333H37.6668ZM16.3335 21.6667H5.66683V48.3333H32.3335V37.6667H21.6668C18.7213 37.6667 16.3335 35.2788 16.3335 32.3333V21.6667Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.7694be1bcbcb8f7fabf0c080f5cff755.svg";
export { ForwardRef as ReactComponent };